<template>
  <b-modal id="BSShowReviewModalID" centered size="lg" @show="showMe">
    <template #modal-header>
      <h2 >{{$t('titles.reviews')}} {{ username_by_id(review.user_id) }} @ {{ project_by_id(contract_by_id(review.contract_id).project_id).title }}</h2>
    </template>
    <p v-html="userinfo(review)"  />
    <div v-if="reviewquestions &&reviewquestions.length>0">
    <div  style="min-height:40px;border:2px solid #aaa;" class="row" v-for="(q,idx) in questions" :key="idx" v-bind:value="q" >
      <div class="col-8">
        {{reviewquestions.filter(q1=>q1.id==q)[0].question}}
      </div>
      <div class="col" v-if="reviews.filter(rv=>rv.question_id==q &&rv.review_id==review.id).length>0">
        <div v-if="reviewquestions.filter(q1=>q1.id==q)[0].question_type==1">
          <star-rating :read-only="true" v-bind:increment="0.5" v-bind:star-size="30" v-model="reviews.filter(rv=>rv.question_id==q &&rv.review_id==review.id)[0].rating"></star-rating>
        </div>
        <div v-if="reviewquestions.filter(q1=>q1.id==q)[0].question_type==2">
          <font-awesome-icon v-if="reviews.filter(rv=>rv.question_id==q &&rv.review_id==review.id)[0].rehire==0" icon="times" style="color: red;" />
            <font-awesome-icon v-else icon="check" style="color: green;" />
            </div>
        <div v-if="reviewquestions.filter(q1=>q1.id==q)[0].question_type==3">
          {{  reviews.filter(rv=>rv.question_id==q &&rv.review_id==review.id)[0] }}
        </div>

      </div>
    </div>
  </div>
    <template #modal-footer>
      <div @click="close_modal" class="btn btn-primary">
       {{ $t('buttons.close') }}
      </div>
    </template>
  </b-modal>
</template>


<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import StarRating from 'vue-star-rating'

export default {
  name: 'invoice-data-modal',
  data() {
    return {
      description:"",
      reviewquestions:[],
      requestquestions:[],
      reviews:[],
      dragging:null,
      reviewssend:null
    }
  },
  props: {
    reviewsend_id: Number
  },
  computed: {

    ...mapState([
      'invoiceextra',
      'current_user',

    ]),
    ...mapGetters([
      'project_by_id',
      'contract_by_id',
      'company_by_id',
      'username_by_id'
    ]),
    fieldsquestions() {
      return [
      { key: 'question', label: this.$i18n.t('labels.question') ,  sortable: true, sortDirection: 'desc' },
      { key: 'question_type', label: this.$i18n.t('labels.questiontype') ,  sortable: true, sortDirection: 'desc' },
      ]
    },
    review(){
      return this.reviewssend?this.reviewssend.filter(r=>r.id==this.reviewsend_id)[0]:[]
    },
    questions(){
      return JSON.parse(this.reviewrequest.filter(req=>req.id==this.review.request_id)[0].questions)


    },


  },
  mounted(){
  this.showMe()      
    
  },
  methods: {
    userinfo(row) {
      let project = this.project_by_id(this.contract_by_id(row.contract_id).project_id)
      let company = this.company_by_id(project.company_id)
      let companyline =   '<strong>'+this.$i18n.t('labels.companyname')+'</strong>  ' +company.company_name + '<br/>' 
      let projectline =   '<strong>'+this.$i18n.t('labels.project')+'</strong>  ' +project.title + '<br/>' 
      let reviewline =  '<strong>'+this.$i18n.t('labels.contactperson')+'</strong> ' + this.username_by_id(row.reviewer_id) + '<br/>' 
      let send = '<strong>'+this.$i18n.t('labels.date')+'</strong>  '+this.dateToNL(row.sent)
      return companyline+projectline+reviewline+send

    },     
    async showMe(){
      await axios.get('/api/reviewssend/all')
      .then((response) => {
        this.reviewssend = response.data
      })
      await axios.get("/api/reviewrequest/all")
        .then((response) => {
          this.reviewrequest =  response.data
          if(this.review_id!=0){
            this.description = this.reviewrequest.filter(req=>req.id==this.review_id)[0].description
            this.requestquestions = JSON.parse(this.reviewrequest.filter(req=>req.id==this.review_id)[0].questions)
            if(this.requestquestions==null){
              this.requestquestions=[]
            }
          }else {
            this.description = ""
            this.requestquestions=[]

          }
      })
        .catch(() => {
        });
      await axios.get("/api/reviewquestions/all")
        .then((response) => {
          this.reviewquestions =  response.data
        })
        .catch(() => {
        });  
    await  axios.get('/api/review/all')
    .then((response) => {
      this.reviews = response.data
    })
    },
    close_modal() {
      this.$bvModal.hide('BSShowReviewModalID')
    },
  },
  components:{StarRating},
}    
</script>
<style>

.questionsselected {
display:flex;
flex-direction: row;
width:100%;

}
.selectedquestion {
border:2px solid black;
 width:30px;
 height:30px;
 margin:5px;
 text-align:center;
 user-select:none;
 
}
.over{
  border:2px red solid !important;
}
</style>